<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="process"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="getLatestProcess"
        :items="optionProcessItems"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        :loading="optionProcessWorking"
        name="process"
        :validators="$v.item"
        :disabled="!!item.id"
        :server-errors="_se"
        v-bind="schema.fields.process"
        allow-add
        store-name="Process"
        add-title="Create New"
      >
        <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <process-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></process-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <table
      class="table table-bordered table-hover table-striped"
      v-if="!!item.id"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Created</th>
          <th scope="col">State -> Transition Name</th>
          <th scope="col">Who</th>
          <th scope="col">Completed</th>
          <th scope="col">Status</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="state in item.states">
          <td>
            <date-display
              :value="state.created_date"
              format="ddd D/MM/yyyy HH:mm"
            />
          </td>
          <td>{{ state.state__name }} -> {{ state.transition__name }}</td>
          <td>{{ state.who__username }}</td>
          <td>
            <date-display
              :value="state.complete_date"
              format="ddd D/MM/yyyy HH:mm"
            />
          </td>
          <td>
            <span class="badge badge-success" v-if="state.is_active"
              >Active</span
            >
            <span class="badge badge-info" v-if="!!state.complete_date"
              >Done</span
            >
          </td>
          <td>
            <trigger-button
              v-if="state.is_active && state.trigger__value.type === 1"
              :trigger="state.trigger__value"
              :instance-id="item.id"
              @success="reload"
            ></trigger-button>
          </td>
        </tr>
      </tbody>
    </table>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../../vue-ocom/components/forms/fields/ODateTime";

import TriggerButton from "@/vue-workflow/components/TriggerButton.vue";
export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("WorkflowInstance"),
    CreateCodeTableFetchMixin(["Process"], {
      filter: "active",
      sort: "created_date",
      order: "desc",
    }),
  ],
  components: {
    TriggerButton,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.WorkflowInstance, {}),
  }),
  methods: {
    reload(data) {
      this.$emit("reload");
    },
  },
  computed: {
    getLatestProcess() {
      if (this.optionProcessItems.length > 0 && !this.item.process) {
        this.formState.dirty = true;
        this.item.process = this.optionProcessItems[0].id;
      }
      return this.item.process;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
